// PreventiveTaskForm.js

import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'reactstrap';
import { formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import PreventiveTaskFormFields from './PreventiveTaskFormFields';

const selector = formValueSelector('PreventiveTaskForm');

export const PreventiveTaskForm = ({
  handleSubmit,
  loading,
  initialValues,
  repeatTypeValue,
  edit,
}) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <PreventiveTaskFormFields
        initialValues={initialValues}
        repeatType={repeatTypeValue}
        edit={edit}
      />

      <FormFooter
        saveButtonDisabled={loading}
        saveButtonIcon={loading ? 'fa fa-spinner fa-spin' : 'fa fa-save'}
      />
    </Form>
  );
};

PreventiveTaskForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  initialValues: PropTypes.shape({}),
  repeatTypeValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  edit: PropTypes.bool,
};

PreventiveTaskForm.defaultProps = {
  loading: false,
  initialValues: null,
  repeatTypeValue: null,
  edit: false,
};

const mapStateToProps = (state) => ({
  repeatTypeValue: selector(state, 'repeatType'),
  resourceScheduleModeValue: selector(state, 'resourceScheduleMode'),
});

const formComponent = reduxForm({
  form: 'PreventiveTaskForm',
  enableReinitialize: true,
})(PreventiveTaskForm);

export default connect(mapStateToProps)(formComponent);
